module.exports = __webpack_public_path__ + "img/dog-walking-ua.9d992b6e.svg";